<template>
    <div class="center-wrap">

        <!-- 左侧：用户卡片 -->
        <div class="left-panel">
            <el-card class="profile-card" shadow="hover">
                <div class="avatar-section">
                    <el-upload
                        class="avatar-uploader"
                        :http-request="uploadFile"
                        accept=".jpg,.png"
                        action=""
                        :show-file-list="false"
                        :before-upload="beforeAvatarUpload">
                        <div class="avatar-wrap">
                            <img v-if="personalForm.avatar" :src="personalForm.avatar" class="avatar-img" />
                            <div v-else class="avatar-placeholder">
                                <i class="el-icon-user-solid" />
                            </div>
                            <div class="avatar-overlay">
                                <i class="el-icon-camera" />
                                <span>更换头像</span>
                            </div>
                        </div>
                    </el-upload>
                    <div class="user-name">{{ userInfo.name || userInfo.username || '用户' }}</div>
                    <div class="user-desc">{{ personalForm.description || '暂无个人简介' }}</div>
                    <el-tag v-if="userInfo.roles" size="small" type="primary" effect="plain" class="role-tag">
                        {{ formatRole(userInfo.roles) }}
                    </el-tag>
                </div>

                <el-divider />

                <div class="info-list">
                    <div class="info-row" v-if="userInfo.phone">
                        <i class="el-icon-phone info-icon" />
                        <span class="info-label">手机号</span>
                        <span class="info-val">{{ userInfo.phone }}</span>
                    </div>
                    <div class="info-row" v-if="userInfo.email">
                        <i class="el-icon-message info-icon" />
                        <span class="info-label">邮箱</span>
                        <span class="info-val">{{ userInfo.email }}</span>
                    </div>
                    <div class="info-row">
                        <i class="el-icon-time info-icon" />
                        <span class="info-label">登录账号</span>
                        <span class="info-val">{{ userInfo.id }}</span>
                    </div>
                </div>
            </el-card>
        </div>

        <!-- 右侧：详情与编辑 -->
        <div class="right-panel">
            <el-card shadow="hover" class="right-card">
                <el-tabs v-model="activeTab">

                    <!-- 基本信息 -->
                    <el-tab-pane label="基本信息" name="info">
                        <div class="tab-content">
                            <div class="section-title"><i class="el-icon-user" /> 账号信息</div>
                            <el-descriptions :column="2" border class="info-desc">
                                <el-descriptions-item label="用户名">{{ userInfo.id }}</el-descriptions-item>
                                <el-descriptions-item label="姓名">{{ userInfo.name || '—' }}</el-descriptions-item>
                                <el-descriptions-item label="性别">{{ userInfo.sex || '—' }}</el-descriptions-item>
                                <el-descriptions-item label="手机号">{{ userInfo.phoneNum || '—' }}</el-descriptions-item>
                                <el-descriptions-item label="邮箱">{{ userInfo.email || '—' }}</el-descriptions-item>
                                <el-descriptions-item label="角色">{{ formatRole(userInfo.roles) }}</el-descriptions-item>
                                <el-descriptions-item label="个人简介" :span="2">{{ userInfo.description || '暂无' }}</el-descriptions-item>
                            </el-descriptions>
                        </div>
                    </el-tab-pane>

                    <!-- 修改资料 -->
                    <el-tab-pane label="修改资料" name="edit">
                        <div class="tab-content">
                            <div class="section-title"><i class="el-icon-edit" /> 编辑个人资料</div>
                            <el-form :model="personalForm" :rules="rules" ref="personalForm" label-width="100px" class="edit-form">
                                <el-form-item label="姓名" prop="name">
                                    <el-input v-model="personalForm.name" placeholder="请输入姓名" maxlength="20" />
                                </el-form-item>
                                <el-form-item label="性别" prop="sex">
                                    <el-radio-group v-model="personalForm.sex">
                                        <el-radio label="男">男</el-radio>
                                        <el-radio label="女">女</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="手机号" prop="phoneNum">
                                    <el-input v-model="personalForm.phoneNum" placeholder="请输入手机号" maxlength="11" />
                                </el-form-item>
                                <el-form-item label="邮箱" prop="email">
                                    <el-input v-model="personalForm.email" placeholder="请输入邮箱" maxlength="100" />
                                </el-form-item>
                                <el-form-item label="个人简介" prop="description">
                                    <el-input
                                        v-model="personalForm.description"
                                        type="textarea"
                                        :rows="3"
                                        maxlength="50"
                                        show-word-limit
                                        placeholder="介绍一下自己..." />
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" icon="el-icon-check" @click="submitInfo">保存修改</el-button>
                                </el-form-item>
                            </el-form>

                            <el-divider content-position="left">更换头像</el-divider>
                            <div class="avatar-edit-section">
                                <el-upload
                                    class="avatar-uploader-large"
                                    :http-request="uploadFile"
                                    accept=".jpg,.png"
                                    action=""
                                    :show-file-list="false"
                                    :before-upload="beforeAvatarUpload">
                                    <div class="avatar-edit-wrap">
                                        <img v-if="personalForm.avatar" :src="personalForm.avatar" class="avatar-edit-img" />
                                        <div v-else class="avatar-edit-placeholder">
                                            <i class="el-icon-plus" />
                                        </div>
                                        <div class="avatar-edit-overlay">
                                            <i class="el-icon-camera" />
                                            <span>点击上传</span>
                                        </div>
                                    </div>
                                </el-upload>
                                <div class="avatar-tip">
                                    <p>· 支持 JPG / PNG 格式</p>
                                    <p>· 文件大小不超过 2MB</p>
                                    <p>· 建议使用正方形图片</p>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>

                </el-tabs>
            </el-card>
        </div>
    </div>
</template>

<script>
export default {
    name: "Center",
    data() {
        return {
            activeTab: 'info',
            userInfo: {},
            personalForm: {
                name: '',
                sex: '',
                phoneNum: '',
                email: '',
                description: '',
                avatar: '',
            },
            rules: {
                name: [{ max: 20, message: '姓名最多20个字', trigger: 'blur' }],
                phoneNum: [{ pattern: /^1\d{10}$/, message: '请输入有效的手机号', trigger: 'blur' }],
                email: [{ type: 'email', message: '请输入有效的邮箱地址', trigger: 'blur' }],
                description: [{ max: 50, message: '最大输入不能超过50个字', trigger: 'blur' }]
            }
        }
    },
    mounted() {
        const user = JSON.parse(window.localStorage.getItem('user'));
        this.userInfo = user || {};
        this.personalForm.name = user.name || '';
        this.personalForm.sex = user.sex || '';
        this.personalForm.phoneNum = user.phoneNum || '';
        this.personalForm.email = user.email || '';
        this.personalForm.description = user.description || '';
        this.personalForm.avatar = user.avatar || '';
    },
    methods: {
        formatRole(roles) {
            if (!roles) return '普通用户';
            if (Array.isArray(roles)) return roles.map(r => r.name || r).join('、');
            return String(roles);
        },
        submitInfo() {
            this.$refs.personalForm.validate(valid => {
                if (!valid) return;
                this.postJsonRequest('/web/user/updateBaseInfo', this.personalForm).then(resp => {
                    if (resp && resp.data && resp.data.status === 200) {
                        this.$message.success('修改成功');
                        // 更新 localStorage 中的用户信息
                        const user = JSON.parse(window.localStorage.getItem('user'));
                        const updated = resp.data.object || {};
                        const merged = { ...user, ...updated };
                        window.localStorage.setItem('user', JSON.stringify(merged));
                        this.userInfo = merged;
                    } else {
                        this.$message.error((resp && resp.data && resp.data.msg) || '修改失败');
                    }
                }).catch(() => {
                    this.$message.error('网络错误，请稍后重试');
                });
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            const user = JSON.parse(window.localStorage.getItem('user'));
            this.personalForm.name = user.name || '';
            this.personalForm.sex = user.sex || '';
            this.personalForm.phoneNum = user.phoneNum || '';
            this.personalForm.email = user.email || '';
            this.personalForm.description = user.description || '';
            this.personalForm.avatar = user.avatar || '';
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG && !isPNG) this.$message.error('上传头像图片只能是 jpg/png 的格式！');
            if (!isLt2M) this.$message.error('上传头像图片大小不能超过 2MB！');
            return (isJPG || isPNG) && isLt2M;
        },
        uploadFile(file) {
            const user = JSON.parse(window.localStorage.getItem('user'));
            const formData = new FormData();
            formData.append('avatar', file.file);
            formData.append('userId', user.id);
            this.postFileRequest('/web/companyInfo/updateLogo', formData).then(response => {
                this.personalForm.avatar = response.data.object.imageUrl;
                this.$message.success('头像上传成功');
            }).catch(() => {
                this.$message.error('上传失败，请稍后重试');
            });
        }
    }
}
</script>

<style scoped>
.center-wrap {
    display: flex;
    gap: 20px;
    padding: 20px 30px;
    align-items: flex-start;
}

/* 左侧面板 */
.left-panel {
    width: 280px;
    flex-shrink: 0;
}

.profile-card {
    border-radius: 10px;
}

.avatar-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 0 4px;
}

/* 头像 */
.avatar-wrap {
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;
    margin-bottom: 14px;
}

.avatar-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.avatar-placeholder {
    width: 100%;
    height: 100%;
    background: #e8f0fe;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 40px;
    color: #409EFF;
}

.avatar-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    font-size: 12px;
    opacity: 0;
    transition: opacity 0.2s;
    border-radius: 50%;
}

.avatar-wrap:hover .avatar-overlay {
    opacity: 1;
}

.avatar-uploader >>> .el-upload {
    border: none;
    border-radius: 50%;
}

.user-name {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 6px;
}

.user-desc {
    font-size: 13px;
    color: #909399;
    text-align: center;
    margin-bottom: 10px;
    padding: 0 10px;
    line-height: 1.5;
}

.role-tag {
    margin-bottom: 4px;
}

/* 信息列表 */
.info-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 4px 0;
}

.info-row {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #606266;
}

.info-icon {
    color: #409EFF;
    font-size: 15px;
    flex-shrink: 0;
}

.info-label {
    color: #909399;
    min-width: 52px;
}

.info-val {
    color: #303133;
    flex: 1;
    word-break: break-all;
}

/* 右侧面板 */
.right-panel {
    flex: 1;
    min-width: 0;
}

.right-card {
    border-radius: 10px;
}

.tab-content {
    padding: 8px 4px;
}

.section-title {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 18px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.section-title i {
    color: #409EFF;
}

/* 基本信息描述表 */
.info-desc {
    margin-bottom: 0;
}

.info-desc >>> .el-descriptions-item__label {
    font-size: 13px;
    color: #606266;
    background: #fafafa;
    width: 100px;
}

.info-desc >>> .el-descriptions-item__content {
    font-size: 13px;
    color: #303133;
}

/* 编辑表单 */
.edit-form {
    max-width: 560px;
}

/* 头像编辑区 */
.avatar-edit-section {
    display: flex;
    align-items: center;
    gap: 24px;
    margin-top: 4px;
}

.avatar-edit-wrap {
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    border: 2px dashed #dcdfe6;
    transition: border-color 0.2s;
}

.avatar-edit-wrap:hover {
    border-color: #409EFF;
}

.avatar-edit-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.avatar-edit-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    color: #c0c4cc;
}

.avatar-edit-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    font-size: 12px;
    opacity: 0;
    transition: opacity 0.2s;
}

.avatar-edit-wrap:hover .avatar-edit-overlay {
    opacity: 1;
}

.avatar-uploader-large >>> .el-upload {
    border: none;
}

.avatar-tip {
    font-size: 12px;
    color: #909399;
    line-height: 2;
}

.avatar-tip p {
    margin: 0;
}
</style>
